import {Constructor} from "../../global/constructor"
import {Hash} from "~/interfaces/hashInterfaces"
import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import ElementHandler from "~/services/elementHandler"
import {IInitialStep} from '~/interfaces/processFlowInterfaces'

export default function ProcessFlowStepContainer<TBase extends Constructor>(Base: TBase) {
  return class StepContainer extends Base {
    steps: Hash<ProcessFlowStep> = {};
    _stepsHandler: ElementHandler<ProcessFlowStep> = new ElementHandler<ProcessFlowStep>(this, ProcessFlowStep, 'steps')
    get stepsHandler(): ElementHandler<ProcessFlowStep> {
      return this._stepsHandler
    }

    get stepsArray(): ProcessFlowStep[] {
      return Object.values(this.steps)
    }

    get initialStep(): IInitialStep {
      return this.stepsArray[0] as IInitialStep
    }
  };
}